// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetNoticeOfIntentChangeRequestWorkForceLinksHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import NoticeOfIntentChangeRequestWorkForceLinkDTO from '../models/NoticeOfIntentChangeRequestWorkForceLinkDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
        },
        initValues);
    },
}

interface Result extends ResultDTO {
    noticeOfIntentChangeRequestWorkForceLinks: NoticeOfIntentChangeRequestWorkForceLinkDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            noticeOfIntentChangeRequestWorkForceLinks: [],
        },
        initValues);
    },
    noticeOfIntentChangeRequestWorkForceLinks: 'noticeOfIntentChangeRequestWorkForceLinks',
}

export { Request, Result };